<template>
    <fade-loader :loading="!value.loaded" :loaded="value.loaded">
        <div class="toolbox-content">
            <h3>In Layer anlegen</h3>
            <div class="formItem">
                <v-select
                        class="sr-select"
                        v-model="selectedLayer"
                        :items="getLayers"
                        :disabled="loading"
                        item-value="id"
                        item-text="title"
                >
                    <template #item="{item}">
                        <simple-svg
                                :filepath="item.iconUrl"
                                :fill="item.color"
                                :stroke="item.stroke"
                        ></simple-svg>
                        <div class="layer-title">{{ item.title}}</div>
                    </template>
                    <template #selection="{item}">
                        <simple-svg
                                :filepath="item.iconUrl"
                                :fill="item.color"
                                :stroke="item.stroke"
                        ></simple-svg>
                        <div class="layer-title">{{ item.title}}</div>
                    </template>
                </v-select>
            </div>
            <h3>Vektor & Verknüpfungen</h3>

            <div class="form-group">
                <div class="form-label"><span>Objekte verknüpfen ({{ value.objects.length }})</span></div>
                <div v-for="object in value.objects" :key="object.id">
                    <div class="formItem formCheckbox single-right">
                        <checkbox v-model="selectedVectors"
                                  :inputValue="object.id"
                                  v-if="object.getLayer().vectorAdoptable"
                                  class="sr-checkbox"></checkbox>
                    </div>
                    <div class="formItem formCheckbox">
                        <checkbox v-model="selectedObjects" :label="object.title" :data="object.getLayer()" :inputValue="object.id" class="sr-checkbox">
                            <template #label="slotProps">
                                <label :for="slotProps.id" data-test="bin da">
                                    <i></i>
                                    <simple-svg
                                            :filepath="slotProps.data.iconUrl"
                                            :fill="slotProps.data.color"
                                            :stroke="slotProps.data.stroke"
                                    ></simple-svg>
                                    <span>
                                        {{ slotProps.data.title }}
                                        <small>{{ slotProps.label }}</small>
                                    </span>
                                </label>
                            </template>
                        </checkbox>
                    </div>
                </div>
                <div class="form-label right"><span>Vektor des Objekts kopieren</span></div>
            </div>
          <div class="empty-state" style="width: 100%">
            Werden mehrere Vektoren ausgewählt, werden diese im neuen Objekt zu einem Vektor zusammengeführt.
          </div>
        </div>
    </fade-loader>
</template>

<script>
  export default {
    props: {
      value: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loadWatcher: null
      }
    },
    mounted () {
      this.value.selectedObjects = []
      this.value.loadingPromise.then(() => {
        for (let i = 0; i < this.value.objects.length; i++) {
          if (this.value.selectedObjects.indexOf(this.value.objects[i].id) === -1) {
            this.selectedObjects.push(this.value.objects[i].id)
          }
        }
      })
    },
    methods: {},
    computed: {
      getLayers () {
        let layers = this.$store.getters['layer/getAll']
        let selectedVectorLayerIds = []
        for (const selectedVector of this.selectedVectors) {
          let selectedVectorLayer = this.value.objects.find((geoObject) => geoObject.id === selectedVector)
          if (selectedVectorLayer) {
            selectedVectorLayerIds.push(selectedVectorLayer.getLayer().id)
          }
        }

        let adoptableLayers = layers.filter((layer) => (layer.objectsAdoptable && !selectedVectorLayerIds.includes(layer.id)) || false)
        return adoptableLayers
      },
      selectedObjects: {
        get () {
          return this.value.selectedObjects
        },
        set (value) {
          this.value.selectedObjects = value
        }
      },
      selectedVectors: {
        get () {
          return this.value.selectedVectors
        },
        set (values) {
          let name = ''
          for (const value of values) {
            let selectedVectorLayer = this.value.objects.find((geoObject) => geoObject.id === value)
            if (selectedVectorLayer) {
              if (selectedVectorLayer.getLayer().id === this.selectedLayer) {
                this.selectedLayer = null
              }
              if (name) {
                name += ' / '
              }
              name += selectedVectorLayer.field_flaechenId.value
            }
          }
          this.$set(this.value, 'field_flaechenId', { value: name })
          this.value.selectedVectors = values
        }
      },
      selectedLayer: {
        get () {
          return this.value.selectedLayer
        },
        set (value) {
          let layer = this.$store.getters['layer/get'](value)
          if (layer) {
            this.value.fieldLayoutId = layer.fieldLayoutId
          }
          this.value.selectedLayer = value
        }
      }
    }
  }
</script>

<style scoped>

</style>
